<template>
  <div class="JingLuoDetail content-small-width">
    <el-row :gutter="22">
      <!-- 左侧部分 -->
      <el-col :span="6" class="left">
        <el-row v-if="jltj">
          <el-col :span="24">
            <div>
              <!-- <img :src="$store.state.imgUrl+jltj" alt class="" style="width:100%" /> -->
              <!-- 轮播图 -->
              <el-carousel class="top-carousel top-carousel-box">
                <el-carousel-item
                  v-for="(items, indexs) in jltj"
                  :key="indexs"
                  class="carousel-img-outer common-img-outer"
                >
                  <!-- <a :href="items" > -->
                  <!-- <img
                    :src="$store.state.imgUrl+items"
                    alt
                    style="width:100%"
                    v-if="indexs == '0'"
                  /> -->
                  <!-- </a> -->
                  <img :src="$store.state.imgUrl+items" alt  style="width:100%"  @click="showBigImg(items)"/>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="imgTip">图片仅供学习参考，侵权请联系下架</div>
          </el-col>
        </el-row>
        <el-row class="l-r-ul-li">
          <el-col :span="24">
            <div class="l-title">
              <img src="../assets/img/jingluo.png" alt /> 其它经络
            </div>
            <ul class="l-ul">
              <li
                v-for="(item, index) in merdiansNameList"
                :key="index"
                @click="getDetail(item.id)"
              >
                {{ item.name }}
              </li>
            </ul>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="adv-wrap">
            <div
              class="common-img-outer setPositon listdetail-adver-outer-img"
              v-for="(item, index) in jingxueAdverList"
              :key="index"
            >
              <a :href="item.urlLink">
                <img :src="$store.state.imgUrl+item.urlImage" alt style="width:100%" />
                <span class="adver-words-tip" v-if="item.urlImage">{{
                  adverWordsTip
                }}</span>
              </a>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <!-- 右侧部分 -->
      <el-col :span="18">
        <el-row style="margin-bottom:20px">
          <el-col :span="17">
            <span class="large-title">{{ name }}</span>
            <span class="browse-count">浏览量：{{ llCount?llCount:0 }}</span>
          </el-col>
          <el-col :span="7" class="btn-group">
            <el-button
              size="small"
              icon="el-icon-star-on"
              class="btn1"
              :class="isCollection ? 'red' : 'grey'"
              @click="collectPer()"
              >收藏</el-button
            >
            <el-button
              size="small"
              icon="el-icon-share"
              class="btn1 grey"
              @click="shareF()"
              >分享</el-button
            >
            <div>
              <share
                :config="config1"
                style="display:inline-block"
                v-if="isShare"
              ></share>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="border-grey"></el-col>
        </el-row>
        <el-row v-if="jlxx">
          <el-col :span="24" class="r-title">经脉循行</el-col>
        </el-row>
        <el-row v-if="jlxx">
          <el-col :span="24" class="r-intro" v-html="jlxx"></el-col>
        </el-row>
        <el-row v-if="jlxxBhj">
          <el-col :span="24" class="r-title">经络循行白话解</el-col>
        </el-row>
        <el-row v-if="jlxxBhj">
          <el-col :span="24" class="r-intro" v-html="jlxxBhj"></el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="r-title">运行时辰</el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="r-intro" v-html="runningTime"></el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="r-title">包含穴位</el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <table class="table">
              <tr>
                <td colspan="4">{{ name }}</td>
              </tr>
              <tr
                v-for="(item, index) in acupointList"
                :key="index"
                v-if="index % 2 == 0"
              >
                <td class="table-title shou" @click="xueweiD( acupointList[index].id)">
                  {{ acupointList[index].name }}
                </td>
                <td class="table-content shou" @click="xueweiD( acupointList[index].id)">
                  ( {{ acupointList[index].pinyin }})
                  <!-- ({{acupointList[index].daihao}}) -->
                  <img
                    src="../assets/img/shuangjiantou-right.png"
                    alt
                    class="fr table-img"
                  />
                </td>
                <td
                  class="table-title shou"
                  v-if="index < acupointList.length - 1"
                  @click="xueweiD( acupointList[index+1].id)"
                >
                  {{ acupointList[index + 1].name }}
                </td>
                <td
                  class="table-content shou"
                  v-if="index < acupointList.length - 1"
                  @click="xueweiD(acupointList[index + 1].id)"
                >
                  ( {{ acupointList[index + 1].pinyin }})
                  <!-- ({{acupointList[index+1].daihao}}) -->
                  <img
                    src="../assets/img/shuangjiantou-right.png"
                    alt
                    class="fr table-img"
                  />
                </td>
              </tr>
            </table>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
        title=""
        :visible.sync="imgVisible"
        width="40%"
        center>
        <div class="bigImg">
            <img :src="$store.state.imgUrl+bigImg" />
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="imgVisible = false">关 闭</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "JingLuoDetail",
  data() {
    return {
      adverList: [], //轮播图
      id: "",
      merdiansNameList: [], //其他经络列表
      isCollection: false, //没有收藏
      jltj: "",
      name: "", //经络名称
      llCount: 0, //浏览次数
      jlxx: "",
      jlxxBhj: "",
      runningTime:"",
      acupointList: [],
      advList: [
        {
          url: require("../assets/img/32.png")
        },
        {
          url: require("../assets/img/33.png")
        }
      ],
      bigImg:'',
      imgVisible:false
    };
  },
  methods: {
    // 收藏和取消收藏
    collectPer() {
      let that = this;
      if (that.isCollection) {
        //已经收藏了
        that.unCollect(that.id, 5);
      } else {
        //还没收藏呢
        that.collect(that.id, 5);
      }
    },
    getDetail(id) {
      let that = this;
      if (sessionStorage.getItem("userInfo")) {
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      }
      let url = "/jlxw/meridians/get";
      let parmas = {
        id: id,
        userId: that.userInfo.id
      };
      that.$http
        .post(url, parmas)
        .then(res => {
          if (res.data.code == 200) {
            let arr = res.data.data;
            // that.jltj = arr.jltj;
            let urls = [];
            if (arr.jltj) {
              if (arr.jltj.charAt(0) === ',') {
                arr.jltj = arr.jltj.substring(1);
                }
                if (arr.jltj.charAt(arr.jltj.length - 1) === ',') {
                  arr.jltj = arr.jltj.slice(0, -1);
                }
              urls = arr.jltj.split(",");
            } else {
              urls = [];
            }
            
            that.jltj = urls;
            that.name = arr.name;
            that.llCount = arr.llCount;
            that.jlxx = arr.jlxx;
            that.jlxxBhj = arr.jlxxBhj;
            that.runningTime = arr.runningTime;
            that.acupointList = arr.acupointList;
            that.isCollection = arr.isCollection == "1" ? true : false;
            that.merdiansNameList = arr.merdiansNameList;
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          that.$message.error("网络错误！");
        });
    },
    xueweiD(id) {
      this.$router.push({
        path: "/xueWeiDetail",
        query: { id, id }
      });
    },
    showBigImg(img){
      this.bigImg = img;
      this.imgVisible = true;
    }
  },
  created() {
    let that = this;
    that.getPositionAdver(5, 3);
    if (!!that.$route.query.id) {
      that.id = that.$route.query.id;
      that.getDetail(that.id);
    }
  }
};
</script>

<style scoped>
.imgTip{
  font-size:12px;
  color: #bbb;
  margin: 10px 0;
}
.img-outer {
  width: 271px;
  height: 368.05px;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.btn-group {
  float: right;
  text-align: right;
}

.table td {
  height: 50px;
}
.table-title {
  width: 120px;
}
.table .table-content {
  text-align: left;
  padding: 0px 17px;
}
.table-img {
  padding: 5px;
}
.bigImg{
  width: 100%;
  display: flex;
  justify-content: center;
}
.bigImg img{
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/JingLuoDetail.vue